import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import VenteChargeEdit from './VenteChargeEdit';
import VentePromoteurEdit from '../vente_list/VentePromoteurEdit';
import { IBienListTable, IAuthReduxProps } from '../../types/interfaces';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';

import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter, DateRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faFileInvoice, faGripLines, faHourglassHalf, faLockOpen, faPen, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import { PRIVILEGE } from '../../types/privileges';
import { constants } from '../../types/constants';
import Association from '../consultation/Association';

const BienListTable = ({ 
  linesData,
  setFilteredRows,
  showProjectColumn,
  auth
 }: IBienListTable) => {
  const skipResetRef = React.useRef(false);
  const history = useHistory();
  const alert = useAlert();
  const [editChargeModal, setEditChargeModal] = useState(false);
  const [editPromoteurModal, setEditPromoteurModal] = useState(false);
  const [modalEditChargeVente, setModalEditChargeVente] = useState('');
  const [modalEditPromoteurVente, setModalEditPromoteurVente] = useState('');
  const [modalAss, setModalAss] = useState(false);
  const [modalAssBien, setModalAssBien] = useState<any>(null);
  const [associationPartInfo, setAssociationPartInfo] = useState<any>('');
  const [modalDoa, setModalDoa] = useState(false);
  const [modalDoaBien, setModalDoaBien] = useState<any>(null);
  
  const modalClosedHandleAss = () => {
    setAssociationPartInfo('')
  };
  
  const handleToggleAss = () => setModalAss(!modalAss);
  
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };

  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/consultation/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/consultation/${id}` })
    }
    else
      alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
  }

  const columns = [
    {
      Header: "Action",
      className: "text-center",
      Cell: ({ row: {original} }) => (
          <Container className="actionsContainer">
              {/*isAssociation && */original.contrat?.associations?.length ? <button className="btn btn-primary btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => (setModalAssBien(original), setModalAss(true))}
                title="Plus d'informations sur l'association">
                <FontAwesomeIcon icon={faGripLines} />
              </button> : null}
              {/* {(("DISPONIBLE" === original.STATUT && !isAssociation) || (["DISPONIBLE", "ASSOCIATION OUVERTE"].includes(original.STATUT) && isAssociation)) && ((!isAssociation || (isAssociation && original.ASS === "1")) ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => setSelectedBien(original)}
                // disabled={!}
                title="Choisir">
                <FontAwesomeIcon icon={faArrowRight} />
              </button> : isAssociation && original.ASS === "0" ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => setModalDoa(true)}
                title="Ouverture en association">
                <FontAwesomeIcon icon={faLockOpen} />
              </button> : null)} */}
              {!!(original.contrat?.id && original.hasPermission) && <PDFLink documentType={"vente"}
                func={async () => getVenteByIdPromise(original.contrat?.id || -1)}
                download={false}
                buttonText=""
                iconSize="inherit"
                // customClassNames="btn btn-info"
                customButtonIcon={faFileInvoice}
                allowPrintPreview={true}
                htmlTitle="Voir la fiche de Vente"
                customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />}
              {original.contrat?.id ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={(e) => viewCard(e, original.contrat?.id)}
                title="Consultation">
                <FontAwesomeIcon icon={faEye} />
              </button> : null}
          </Container>
      ),
      disableSortBy: true,
    },
    {
      Header: "ID Bien",
      accessor: "id",
      hidden: true
    },
    {
      Header: "Projet",
      accessor: "PROJET",
      Filter: SelectColumnFilter,
      filter: 'equals',
      hidden: true
    },
    {
      Header: "Statut",
      accessor: "STATUT",
      Filter: SelectColumnFilter,
      filter: 'equals',
    },
    {
      Header: "Désignation",
      accessor: "DESIGNATION",
    },
    {
      Header: "N°",
      accessor: "N",
      className: "minTableCellWidth",
      filter: 'equals',
    },
    // {
    //   Header: "Type",
    //   accessor: "TYPE_2",
    //   customExportDisplay: `$.TYPE || "-"`,
    //   Filter: (e) => SelectColumnFilter({...e, capitalizeFirst: true}),
    //   filter: 'equals',
    //   Cell: ({ row }) => row.original.TYPE || "-"
    // },
    {
      Header: "Type",
      accessor: "TYPE",
      customExportDisplay: `$.TYPE || "-"`,
      filter: (rows, id, e) => rows.filter(t => (t.original[id]?.toLowerCase().includes("app") ? "Appartement" : t.original[id]?.toLowerCase().includes("mag") ? "Magasin" : (t.original[id] || "")).toLowerCase().includes(e?.toLowerCase() || "")),
      Cell: ({ row }) => row.original.TYPE?.toLowerCase().includes("app") ? "Appartement" : row.original.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (row.original.TYPE || "-")
    },
    {
      Header: "Tranche",
      accessor: "TRANCHE",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Immeuble",
      accessor: "IMMEUBLE",
      Cell: ({ value }) => !value && value !== "0" ? "-" : value
    },
    {
      Header: "Étage",
      accessor: "ETAGE",
      // Filter: SelectColumnFilter,
      // filter: 'equals',
      Cell: ({ value }) => !value && value !== "0" ? "-" : value
    },
    {
      Header: "Étages",
      accessor: "ETAGE_ASS",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Superficie",
      accessor: "SUPERFICIE",
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      Cell: ({ value, row }) => row.original.TYPE_2?.toLowerCase() === "appartement" ? "-" : (value + "m²")
    },
    ...(!!auth?.user?.privileges?.includes(PRIVILEGE.SEE_PRIX_MIN) ? [{
      Header: "Prix du bien MIN en M²",
      accessor: e => Number(e.PRIX_M_MIN || 0),
      hidden: true,
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Prix du bien MIN",
      accessor: e => Number(e.PRIX_VENTE_MIN || 0),
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") || (row.original.PRIX_M_MIN !== null && row.original.PRIX_M_MIN !== undefined && row.original.PRIX_M_MIN != "") ? (<div><div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.Header === "Prix du bien MIN en M²")?.isVisible && (row.original.PRIX_M_MIN !== null && row.original.PRIX_M_MIN !== undefined && row.original.PRIX_M_MIN != "") ? (" (" + ((row.original.PRIX_M_MIN.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")) + "/m²)") : "")}</div></div>) : "-"
    }] : []),
    {
      Header: "Prix du M²",
      accessor: "PRIX_M",
      hidden: true,
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
      sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                  > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Prix du bien",
      accessor: "PRIX_VENTE",
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
      sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                  > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
      Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") || (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (<div><div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.id === "PRIX_M")?.isVisible && (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (" (" + ((row.original.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")) + "/m²)") : "")}</div></div>) : "-"
    },
    // ...(isAssociation ? [{
    //   Header: "Étages",
    //   disableSortBy: true,
    //   disableFilters: true,
    //   Cell: ({ row: {original} }) => {
    //     if(original.contrat?.associations?.length){
    //       const associationsSorted = original.contrat.associations.sort((a, b) => a.ETAGE - b.ETAGE);
    //       return <div>
    //         {associationsSorted.map((e, key) => <div key={key} style={{width: "100%", border: "1px solid", borderRadius: "5px"}}>
    //           <b>{e.POURCENTAGE}</b>% de l'étage <b>{e.ETAGE}</b> à <b>{(e.PRIX_VENTE !== null && e.PRIX_VENTE !== undefined && e.PRIX_VENTE != "") ? (e.PRIX_VENTE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}</b>
    //         </div>)}
    //       </div>
    //     }
    //     else
    //       return "-"
    //   }
    // }] : []),
    {
      Header: "Titre foncier",
      accessor: "TF",
      Cell: ({ value }) => value || "-",
      // hidden: true
    },
    {
      Header: "Conditions de paiement",
      accessor: e => {
        const minEncIsNumber = e.minEncIsNumber == 1
        const minEnc = Number(e.minEnc || 0)
        const minEnc1Month = Number(e.minEnc1Month || 0)
        const minEnc3Months = Number(e.minEnc3Months || 0)
        const minEnc6Months = Number(e.minEnc6Months || 0)
        const minEnc9Months = Number(e.minEnc9Months || 0)
        if(!minEnc && !minEnc1Month && !minEnc3Months && !minEnc6Months && !minEnc9Months)
          return "Sans"
        if(minEncIsNumber)
          return `${minEnc.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh`
        else{
          let str = ""
          if(minEnc1Month + minEnc3Months + minEnc6Months + minEnc9Months !== minEnc)
            str += `${minEnc}% Total`
          if(minEnc1Month)
            str += ` \n${minEnc1Month}% 1 mois`
          if(minEnc3Months)
            str += ` \n${minEnc3Months}% 3 mois`
          if(minEnc6Months)
            str += ` \n${minEnc6Months}% 6 mois`
          if(minEnc9Months)
            str += ` \n${minEnc9Months}% 9 mois`
          return str
        }
      },
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "ID vente",
      id: "ID vente",
      accessor: (row, index) => row.contrat?.id,
      Cell: ({ value }) => {
        return (<a href={value !== null && value !== undefined ? (`/consultation/${value}`) : '/#'} onClick={(e) => {
          e.preventDefault();
          if(value !== null && value !== undefined){
            if (e.ctrlKey){
              window.open('/consultation/' + value,'_blank');
              return;
            }
            history.push({ pathname: `/consultation/${value}` })
          }
          else
            alert.error(E_ERROR.NO_CLIENT_WITH_THIS_ID)
        }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
      }
    },
    {
      Header: "N° Dossier",
      id: "N° Dossier",
      accessor: row => row.contrat?.NUM_DOSS,
      filter: 'equals',
      // accessor: "NUM_DOSS",
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Date Vente",
      id: "Date Vente",
      accessor: row => row.contrat?.DATE_RESERV,
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Type Vente",
      id: "Type Vente",
      accessor: (row, index) => row.contrat?.TYPE_VENTE === "UNIQUE" ? "Normale" : row.contrat?.TYPE_VENTE === "ASSOCIATION" ? "Association" : (row.contrat?.TYPE_VENTE || ""),
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value, row: {original} }) => value || "-",
    },
    {
      Header: "Prix Net du M²",
      accessor: e => Number(e.contrat?.PRIX_M || 0),
      hidden: true,
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
      sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                  > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Prix Net",
      accessor: row => Number(row.contrat?.PRIX_NET || 0),
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") || (row.original.contrat?.PRIX_M !== null && row.original.contrat?.PRIX_M !== undefined && row.original.contrat?.PRIX_M != "") ? (<div><div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.Header === "Prix Net du M²")?.isVisible && (row.original.contrat?.PRIX_M !== null && row.original.contrat?.PRIX_M !== undefined && row.original.contrat?.PRIX_M != "") ? (" (" + ((row.original.contrat?.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")) + "/m²)") : "")}</div></div>) : "-"
    },
    {
      Header: "Avance",
      id: "Avance",
      accessor: row => row.contrat?.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0,
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => {
        const prixNet = Number(row.original.contrat?.PRIX_NET || 0);
        return value ? (<>
          {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
          {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
        </>) : "-"
      }
    },
    {
      Header: "Reliquat",
      id: "Reliquat",
      accessor: row => {
        const prixNet = Number(row.contrat?.PRIX_NET || 0);
        return (prixNet || 0) - (row.contrat?.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)
      },
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => value ? (<>
        {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh
      </>) : "-"
    },
    {
      Header: "Prix Somme Parts",
      id: "Prix Somme Parts",
      accessor: row => Number((row.contrat?.TYPE_VENTE !== "ASSOCIATION" ? row.contrat?.PRIX_NET : (row.contrat?.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)) || 0),
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") ? (<div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}</div>) : "-"
    },
    {
      Header: "Avance (Parts)",
      id: "Avance (Parts)",
      accessor: row => Number(row.contrat?.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0),
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => {
        const prixNet = row.original.TYPE_VENTE !== "ASSOCIATION" ? row.original.PRIX_NET : (row.original.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0);
        return value ? (<>
          {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
          {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
        </>) : "-"
      }
    },
    {
      Header: "Reliquat (Parts)",
      id: "Reliquat (Parts)",
      accessor: row => {
        const prixNet = Number((row.contrat?.TYPE_VENTE !== "ASSOCIATION" ? row.contrat?.PRIX_NET : (row.contrat?.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)) || 0);
        return (prixNet || 0) - (row.contrat?.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)
      },
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      Cell: ({ value, row, columns }) => value ? (<>
        {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh
      </>) : "-"
    },{
      Header: "Client(s)",
      id: "Client(s)",
      accessor: row => row.contrat?.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [],
      customExportDisplay: `(($.contrat ? $.contrat.contrat_clients : undefined) ? ($.contrat ? $.contrat.contrat_clients : undefined) : []).map(e => e.client).filter((value, index, self) => (!value || value.id === undefined) || self.findIndex(e => (e ? e.id : undefined) === (value ? value.id : undefined)) === index).map(e => e ? (e.NOM + " " + e.PRENOM) : "-").join(" / ")`,
      filter: (rows, id, e) => rows.filter(t => (t.original[id] || []).filter(m => (e || "").split(" ").length === 2 ? 
        ((m.NOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[0]) && m.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[1])) || (m.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[0]) && m.NOM?.toString().toLowerCase().includes((e || "").toLowerCase().split(" ")[1])))
        : (e || "").toLowerCase().split(" ").filter(n => m.NOM?.toString().toLowerCase().includes(n) || m.PRENOM?.toString().toLowerCase().includes(n)).length > 0).length),
      disableSortBy: true,
      Cell: ({ value }) => value?.length ? value.map(e => e ? <div className="tableCellBlocks">{`${e.NOM} ${e.PRENOM}`}</div> : null) : "-"
    },
    {
      Header: "Téléphone(s)",
      id: "Téléphone(s)",
      // accessor: "contrat_clients",
      customExportDisplay: `(($.contrat ? $.contrat.contrat_clients : undefined) ? ($.contrat ? $.contrat.contrat_clients : undefined) : []).map(e => e.client).filter((value, index, self) => (!value || value.id === undefined) || self.findIndex(e => (e ? e.id : undefined) === (value ? value.id : undefined)) === index).map(e => e ? (e.TEL + (e.TEL2 ? (" - " + e.TEL2) : "")) : "-").join(" / ")`,
      accessor: row => row.contrat?.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [],
      filter: (rows, id, e) => rows.filter(t => (t.original[id] || []).filter(m => m.TEL?.toString().toLowerCase().includes(e || "") || m.TEL2?.toString().toLowerCase().includes(e || "")).length),
      disableSortBy: true,
      Cell: ({ value }) => value?.length ? value.map(e => <div className="tableCellBlocks">
        {e?.TEL ? <div style={{whiteSpace: "nowrap"}}>
          {e.TEL.length >= 4 && e.TEL[0] !== "0" ? ("+" + e.TEL) : e.TEL}
          <a data-tip data-for="telI" href={`tel:${(e.TEL.length >= 4 && e.TEL[0] !== "0" ? ("+" + e.TEL) : e.TEL).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
          <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
          <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(e.TEL)} />
          <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
            <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
          </ReactTooltip>
        </div> : null}
        {e?.TEL2 ? <div style={{whiteSpace: "nowrap"}}>
          {e.TEL2.length >= 4 && e.TEL2[0] !== "0" ? ("+" + e.TEL2) : e.TEL2}
          <a data-tip data-for="telI2" href={`tel:${(e.TEL2.length >= 4 && e.TEL2[0] !== "0" ? ("+" + e.TEL2) : e.TEL2).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
          <ReactTooltip effect="solid" place="bottom" id="telI2" type="dark"><b>Appeler</b></ReactTooltip>
          <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(e.TEL2, 2)} />
          <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
            <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
          </ReactTooltip>
        </div> : null}
        {!e?.TEL && !e?.TEL2 ? "-" : null}
      </div>) : "-"
    },
    {
      Header: "Statut Notaire",
      id: "Statut Notaire",
      accessor: (row, index) => row.contrat?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "Signé notaire" : !!row.contrat?.en_cours_signature ? "Signature en cours" : !!row.contrat?.chez_notaire ? "Signé client" : "Pas encore signé",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Promoteur",
      accessor: e => e.contrat?.promoteurUser?.name,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Commercial",
      accessor: e => e.contrat?.comUser?.LOGIN,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Chargé du bien",
      accessor: e => e.contrat?.chargeBienUser?.LOGIN,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Bénéficiaire de commission",
      accessor: e => e.contrat?.commissionedToVUser?.LOGIN,
      Cell: ({ value }) => value || "-"
    },
];

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [linesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} setFilteredRows={setFilteredRows} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <VenteChargeEdit modal={editChargeModal} setModal={setEditChargeModal} modalVente={modalEditChargeVente} />
      <VentePromoteurEdit modal={editPromoteurModal} setModal={setEditPromoteurModal} modalVente={modalEditPromoteurVente} />

      <Modal isOpen={modalAss} toggle={handleToggleAss} onClosed={modalClosedHandleAss} className="modal-dialog-large" style={{minWidth: "900px"}} modalClassName="xOverflowModal">
        <ModalHeader toggle={handleToggleAss}><FontAwesomeIcon icon={faGripLines} />&nbsp;&nbsp;Détails de l'association</ModalHeader>
        <ModalBody>
          <Association associations={modalAssBien?.contrat?.associations} etages={modalAssBien?.ETAGE_ASS} associationPartInfo={associationPartInfo} setAssociationPartInfo={setAssociationPartInfo} isModal />
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, {})(BienListTable);
